var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "3s9qkpm97a",
    d: "M0.978 0.923L447.626 0.923 447.626 159.883 0.978 159.883z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC6F3",
    d: "M36.019 375.891L91.405 375.891 91.405 152.037 36.019 152.037zM144.947 381.66L200.334 381.66 200.334 147.036 144.947 147.036zM250.876 381.66L306.262 381.66 306.262 147.036 250.876 147.036zM356.803 381.66L412.19 381.66 412.19 147.036 356.803 147.036z",
    transform: "translate(49 37)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49 37) translate(0 .077) translate(1)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "xqhkzv2nfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3s9qkpm97a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M224.302 17.93c-.155 0-.312.03-.46.092L18.74 101.548c-.462.189-.761.632-.761 1.13v38.984c0 .674.548 1.22 1.22 1.22h410.208c.672 0 1.22-.546 1.22-1.22v-38.983c0-.5-.298-.943-.76-1.131L224.763 18.022c-.15-.061-.305-.091-.461-.091m205.104 141.952H19.198c-10.046 0-18.22-8.174-18.22-18.221v-38.983c0-7.444 4.455-14.068 11.349-16.875L217.43 2.278c4.433-1.807 9.313-1.806 13.746 0l205.103 83.526c6.893 2.808 11.347 9.43 11.347 16.875v38.983c0 10.047-8.174 18.22-18.22 18.22",
    mask: "url(#xqhkzv2nfb)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M18.5 384.2c-.827 0-1.5.674-1.5 1.5v51.8c0 .827.673 1.5 1.5 1.5h414.289c.827 0 1.5-.673 1.5-1.5v-51.8c0-.826-.673-1.5-1.5-1.5H18.5zM432.789 456H18.5C8.299 456 0 447.7 0 437.5v-51.8c0-10.2 8.299-18.5 18.5-18.5h414.289c10.201 0 18.5 8.3 18.5 18.5v51.8c0 10.2-8.299 18.5-18.5 18.5zM246.32 88.483c0-11.42-9.257-20.676-20.676-20.676-11.419 0-20.676 9.257-20.676 20.676 0 11.419 9.257 20.676 20.676 20.676 11.42 0 20.676-9.257 20.676-20.676",
    transform: "translate(49 37) translate(0 .077)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOop);
export default __webpack_public_path__ + "static/media/icon--oop.f2725734c2b75d3e67f055b35ef1fc4b.svg";
export { ForwardRef as ReactComponent };